<div class="mobile-canvas-container " [class.has-toolbar]="navbarStatus" [ngClass]="selectedTheme" [class.screenblur]="spinnerActive">
  <mat-toolbar  *ngIf="navbarStatus" class="navbarM3" (click)="openNavProperties()">
    <button mat-icon-button class="navbarM3"  aria-label="Example icon-button with menu icon">
      <mat-icon>menu</mat-icon>
    </button>
    <span class="logo" *ngIf="navConfig?.selectedOption == 'logo'"><img [src]="getImageFile(navConfig?.logo)"
        alt="logo" /></span>
    <span class="ms-1" *ngIf="navConfig?.selectedOption == 'title'">
      <h4>{{navConfig?.title}}</h4>
    </span>
    <span class="flex-fill"></span>

    <div class="menu-items">
      <ng-container *ngFor="let page of navConfig?.pages">
        <button mat-button class="navbarM3" *ngIf="page.enable"
          >{{page.name}}</button>
      </ng-container>
    </div>
    <div class="buttons">
      <div class="profile" *ngIf="navConfig?.userInfo">
        <div class="avatar">
          {{userInfo?.username[0] | titlecase}}
        </div>
        {{userInfo?.username}}
      </div>
      <button mat-icon-button class="navbarM3" *ngIf="navConfig?.logoutOption" 
        aria-label="Example icon-button with logout icon">
        <mat-icon>logout</mat-icon>
      </button>
    </div>

  </mat-toolbar>

  <mat-drawer-container class="wb-sidemenu-container">
    <mat-drawer #drawer class="wb-sidemenu" mode="over">

      <div class="wb-sidemenu-content">

        <div class="wb-sidemenu-items">
          <ng-container *ngFor="let page of menuConfig?.pages">

            <button mat-button *ngIf="page.enable">
              <mat-icon>wysiwyg</mat-icon> {{ page.name }}
            </button>
          </ng-container>
        </div>
        <div class="wb-sidemenu-footer">
          <button mat-button *ngIf="menuConfig?.userInfo">
            <mat-icon>person</mat-icon> {{userInfo?.username}}

            <!-- {{userInfo?.username[0] | titlecase}} -->
          </button>
          <button mat-button *ngIf="menuConfig?.logoutOption" color="warn">
            <mat-icon>logout</mat-icon> Logout
          </button>


        </div>
      </div>

    </mat-drawer>
    <ngx-gridster [options]="gridsterOptions" [draggableOptions]="gridsterDraggableOptions"
      (optionsChange)="change($event)" class="dashboard h-100" *ngIf="pageData && displayOnScreenResize">
      <ngx-gridster-item #gridItem *ngFor="let widget of gridSterItems; let i = index" [class.inDragState]="inDragState" (start)="inDragState = true" (end)="inDragState = false"
        (change)="itemChange($event, widget, undefined, 'widget')" (end)="itemChanged($event,i)"
        [dragAndDrop]="widget.widgetConfig.responsiveOptions?.dragAndDrop || true"
        [resizable]="widget.widgetConfig.responsiveOptions?.resizable || true" [(x)]="widget.widgetConfig.dimentions.x"
        [(y)]="widget.widgetConfig.dimentions.y" [(xSm)]="widget.widgetConfig.responsiveOptions.xSm"
        [(ySm)]="widget.widgetConfig.responsiveOptions.ySm" [(xMd)]="widget.widgetConfig.responsiveOptions.xMd"
        [(yMd)]="widget.widgetConfig.responsiveOptions.yMd" [(xLg)]="widget.widgetConfig.responsiveOptions.xLg"
        [(yLg)]="widget.widgetConfig.responsiveOptions.yLg" [(xXl)]="widget.widgetConfig.responsiveOptions.xXl"
        [(yXl)]="widget.widgetConfig.responsiveOptions.yXl" [(w)]="widget.widgetConfig.dimentions.w"
        [(wSm)]="widget.widgetConfig.responsiveOptions.wSm" [(hSm)]="widget.widgetConfig.responsiveOptions.hSm"
          [(wMd)]="widget.widgetConfig.responsiveOptions.wMd" [(hMd)]="widget.widgetConfig.responsiveOptions.hMd"
          [(wLg)]="widget.widgetConfig.responsiveOptions.wLg" [(hLg)]="widget.widgetConfig.responsiveOptions.hLg"
          [(wXl)]="widget.widgetConfig.responsiveOptions.wXl" [(hXl)]="widget.widgetConfig.responsiveOptions.hXl"
          [ngClass]="{'display-widget' : displayWidgetCharts.includes(widget.widgetType)}" >
          
            <div class="panel-heading  mb-item-widget">
              <div class="mb-widget-action" *ngIf="!excludedPages.includes(pageData.pageType ?? '')">
                <button mat-mini-fab matTooltip="Delete Widget" matTooltipPosition="above"
                  (click)="deleteWidget(pageData, i, widget)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <lib-web-widget-filter [widget]="widget" [class.selected-widget]="widget.open" [page]="pageData" [gridItemHeigthWidth]="{height:gridItem.$element.offsetHeight,width:gridItem.$element.offsetWidth}"></lib-web-widget-filter>
            </div>
        </ngx-gridster-item>
      </ngx-gridster>
    </mat-drawer-container>

  </div>

  <div *ngIf="spinnerActive" class="spinnerCenter">
    <mat-spinner diameter="40" ></mat-spinner>
  </div>